module.exports = __webpack_public_path__ + "img/f-thermometer-img4-2.b14d4746.png";